import { c as _c } from "react/compiler-runtime";
import { ViewModeSelector } from "@components/view-mode-selector/view-mode-selector";
import { useMediaQueryList } from "@hooks/use-media-query";
import { CreateProjectDialog } from "@pages/projects/create-project-dialog";

/** Returns the action buttons of the projects tab */
export function ProjectsTabActionButtons() {
  const $ = _c(1);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  if (isScreenSmOrSmaller) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><ViewModeSelector subject="projects" /><CreateProjectDialog /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}